import MockRepo from '../../../repos/MockRepo';

export default class LoginRepoMock extends MockRepo {
    
    loginHr(googleToken){
        if(googleToken==='1111')
            return Promise.resolve({error:'not valid'});
        return Promise.resolve({"user":{"id":1,"username":"kalos","email":"cmiraglia@taal.it","created_at":null,"updated_at":null},"access_token":{"type":"bearer","token":"7cfe3d8c4d892b199c1860fbfea3a2adTq+Yul14lGourD1qPCJc53+oLh03OJHsDv4tfh7c69th1IGXO1kAJdsWlc5LKSbF"}});
    }
}